<template>
  <div class="animated fadeIn">
    <div class="card card-body">
      <!-- User defined configs not implemented yet -->
      <!-- <div class="row">
        <div class="col-md-4">
          <div class="dx-field-label smallFont">Configured ratios:</div>
          <treeselect :placeholder="$t('Webportal.BrandFilter.Placeholder')"
              ref="ratioSelection"
              instance-id="ratio"
              v-model="ratioSelection"
              :options="ratioValues"
              :auto-load-root-options="false"
              :multiple="false"
              :searchable="true"
              :disableFuzzyMatching="true"
              :showCount="false"
              :flat="true"
              showCountOf="LEAF_DESCENDANTS"
              :disable-branch-nodes="true"
              @close="handleRatioClose"
              @input="handleRatioInput" />
        </div>
      </div> -->
      <div class="container-fluid">
        <div class="col-md-8">
          <div class="row justify-content-end">
            <div class="col-auto">
              {{ $t('Webportal.Dashboard.FunnelCalculationMode') }}
              <span v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Dashboard.FunnelCalculationMode.Description')">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
              </span>
            </div>
            <div class="col-auto">
              <label class="switch switch-label switch-secondary space-left">
                <input class="switch-input" type="checkbox" v-model="calculationModeAbs" @change="onCalcModechanged"/>
                <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="surveySelectionIsValid && questions" class="row">
          <div class="col-md-8">
            <div class="row align-items-center minHeight400">
              <template v-for="(line, index) of this.currentLines" :key="index">
                <div class="col-md-6 pb-2" :class="{ firstAndLastLine: index===0 || isIndexLastAndNotFirst(index) }">
                  <label v-if="isIndexLastAndNotFirst(index)" :key="`${index}_end`" class="dx-field-label start-end-question">
                    <font-awesome-icon :icon="['fas', 'bullseye-arrow']"/>
                    {{$t('Webportal.Dashboard.Funnel.EndQuestion')}}:
                  </label>
                  <label v-if="index===0" :key="`${index}_start`" class="dx-field-label start-end-question">
                    <font-awesome-icon :icon="['far', 'rocket']"/>
                    {{$t('Webportal.Dashboard.Funnel.StartQuestion')}}:
                  </label>
                  <label :for="`selq${index}`" class="dx-field-label smallFont">{{$t('Webportal.Question')}}:</label>
                  <b-form-select
                    :id="`selq${index}`"
                    v-model="line.questionId"
                    style="white-space: normal;height: 60px;word-wrap: break-word;"
                    @input="handleQuestionInput">
                    <template v-for="(question, index) of getQuestionOptions()" :key="index">
                      <option :value="question.id">{{question.label}}</option>
                    </template>
                  </b-form-select>
                </div>
                <div class="col-md-5 pb-2" :class="{ firstAndLastLine: index===0 || isIndexLastAndNotFirst(index) }">
                  <label v-if="isIndexLastAndNotFirst(index)" :key="`${index}_end`" class="dx-field-label start-end-question">&nbsp;</label>
                  <label v-if="index===0" :key="`${index}_start2`" class="dx-field-label start-end-question">&nbsp;</label>
                  <label :for="`sela${index}`" class="dx-field-label smallFont">{{$t('Webportal.Answer')}}:</label>
                  <b-form-select
                    :id="`sela${index}`"
                    v-model="line.answerId"
                    style="white-space: normal;height: 60px;word-wrap: break-word;"
                    @input="handleAnswerInput"
                    @change="handleAnswerClose(index)">
                    <template v-for="(answer, index) of getAnswerOptions(line.questionId)" :key="index">
                      <option :value="answer.id">{{answer.label}}</option>
                    </template>
                  </b-form-select>
                </div>
                <div class="col-md-1">
                  <label v-if="isIndexLastAndNotFirst(index)" :key="`${index}_end`" class="dx-field-label start-end-question">&nbsp;</label>
                  <label v-if="index===0" :key="`${index}_start2`" class="dx-field-label start-end-question">&nbsp;</label>
                  <b-button v-if="showAddRemoveButton(index)"
                            variant="primary"
                            @click="handleAddRemoveLine(index)"
                            size="sm"
                            v-b-tooltip.hover
                            :title="getAddRemoveText(index)"
                            style="margin-top: 35px;min-width: 31px;">
                    {{getAddRemoveText(index)}}
                  </b-button>
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-4">
            <div class="funnel-background p-3">
              <dx-funnel  :dataSource="currentFunnelData"
                          argumentField="label"
                          valueField="value"
                          :palette="colors"
                          :sortData="false">
                <dx-label
                  backgroundColor="none"
                  :customizeText="getResultText"
                  position="inside">
                  <dx-font :size="16" :weight="400" color="#fff"/>
                </dx-label>
                <dx-tooltip :enabled="true" :customizeTooltip="getResultText"/>
              </dx-funnel>
            </div>
          </div>
        </div>
      </div>
      <div v-if="surveySelectionIsValid && !questions">
        {{ $t('Webportal.NoDataFound')}}
      </div>
      <div v-if="!surveySelectionIsValid">
        {{ $t('Webportal.Dashboard.NoMultisurveyAllowed')}}
      </div>
    </div>
  </div>
</template>

<script>

  import axios from 'axios';
  import EventBus from '@/services/EventBus.js'
  import DashboardService from '@/services/DashboardService';
  import {DxFunnel, DxLabel, DxTooltip, DxFont} from 'devextreme-vue/funnel'

  export default {
    name: 'DashboardPanelFunnel',

    props:{
      percentageNumberOfDecimalPoints: {type: Number, default: 2},
      filtervalues: null,
      selection: null
    },

    watch: {
      selection: {
        handler(newVal, oldVal) {
          if (this.checkFilterChanged(newVal, oldVal) && this.checkSurveySelectionIsValid()) {
            // console.log('DashboardPanelFunnel - watch - selection');
            this.getFunneldata();
          }
        },
      },
    },

    components:{
      DxFunnel,
      DxLabel,
      DxTooltip,
      DxFont
    },

    data() {
      return {

        toolTipDelay: { delay: { "show": 500, "hide": 100 } },
        cockpitCancelToken: null,
        isLoading: false,

        funneldata: null,
        currentLines: [{
          questionId: null,
          answerId: null,
        },{
          questionId: null,
          answerId: null,
        }],

        questions: null,

        lastAnswers: [],

        surveySelectionIsValid: false,

        currentFunnelData: [],

        calculationModeAbs: false,

        colors: [
          "#258039",
          "#f5be41",
          "#31a9b8",
          "#cf3721",
        ]
      }
    },

    created() {
      if (!this.questions && this.checkSurveySelectionIsValid()) {
        this.getFunneldata();
      }
      EventBus.$on('LocalizationChanged', this.localizationChanged);
    },

    mounted() {
      this.reInitializeFunnelData();
    },

    beforeUnmount() {
      // console.log('Dashboard - beforeUnmount');
      EventBus.$off('LocalizationChanged', this.localizationChanged);
    },

    methods:{

      localizationChanged(localizationId) {
        this.getFunneldata(false);
        this.reInitializeFunnelData();
      },

      onCalcModechanged(value) {
        this.reInitializeFunnelData();
      },

      isIndexLastAndNotFirst(index) {
        //console.log('DashboardPanelFunnel - isIndexLast - index: ' + index + ' / items: ' + this.currentLines.length);
        return index>0 && index===this.currentLines.length-1;
      },

      showAddRemoveButton(index) {
        // console.log('DashboardPanelFunnel - showAddRemoveButton - index: ' + index + ' / items: ' + this.currentLines.length);
        let retVal = true;

        if (index > 0 && this.isIndexLastAndNotFirst(index)) {
          retVal = false;
        }

        return retVal;
      },

      getAddRemoveText(index) {

        // console.log('DashboardPanelFunnel - getAddRemoveText - index: ' + index + ' length: ' + this.currentLines.length);
        let retVal = "-";

        if (index === 0 || index === this.currentLines.length-1) {
          retVal = "+";
        }

        return retVal;
      },

      handleQuestionClose(value, instance) {
        // console.log('DashboardPanelFunnel - handleQuestionClose');
        // console.log(value);
        // console.log(instance);

        const index = Number(instance);
        if (!Number.isNaN(index)) {
          this.currentLines[index].answerId = null;
        }
      },

      handleAnswerClose(instance) {
        // console.log('DashboardPanelFunnel - handleAnswerClose');
        // console.log(instance);

        const index = Number(instance);
        const value = this.currentLines[index].answerId;
        // console.log(value);

        if (this.lastAnswers && !Number.isNaN(index)) {
          if (this.lastAnswers.length <= index || this.lastAnswers[index] != value) {
            this.lastAnswers[index] = value;
            this.reInitializeFunnelData();
          }
        }
      },

      handleQuestionInput(value, instance) {
        // console.log('DashboardPanelFunnel - handleQuestionInput');
        // console.log(value);
        // console.log(instance);

        const index = Number(instance);
        if (!Number.isNaN(index)) {
          this.currentLines[index].answerId = null;
        }
      },

      handleAnswerInput(value, instance) {
        // console.log('DashboardPanelFunnel - handleAnswerInput');
        // console.log(value);
        // console.log(instance);
        // console.log(this.lastAnswers);

        const index = Number(instance);
        if (!value && !Number.isNaN(index) && this.lastAnswers.length > index && this.lastAnswers[index] != value) {
          this.lastAnswers[index] = value;
          this.reInitializeFunnelData();
        } else if (this.lastAnswers.length === 0) {
          this.lastAnswers.push(value);
          this.reInitializeFunnelData();
        }
      },

      handleAddRemoveLine(index) {
        if (index === 0 || index === this.currentLines.length-1) {
          this.addNewLine();
        } else {
          this.removeLine(index);
        }

        this.reInitializeFunnelData();
      },

      addNewLine() {
        // console.log('DashboardPanelFunnel - addNewLine');

        // add new line and change reference by copying all items
        this.currentLines =
          [...this.currentLines.splice(0, this.currentLines.length - 1),
            {questionId: null,answerId: null,},
              this.currentLines.pop()];

        // console.log(this.currentLines);
      },

      removeLine(index) {

        if (this.currentLines && this.currentLines.length > index && this.currentLines.length > 1) {
          // console.log('DashboardPanelFunnel - removeLine: ' + index);
          this.currentLines.splice(index, 1);
          // console.log(this.currentLines);
        }
      },

      reInitializeFunnelData() {

        // console.log('DashboardPanelFunnel - reInitializeFunnelData');

        if (this.lastAnswers && this.lastAnswers.length > 0) {

          const answerIds = this.lastAnswers.filter(obj => obj != null && obj != undefined).join();

          // read funnelresults
          if (answerIds && answerIds.length > 0) {

            const token = this.initCancelToken(this.cockpitCancelToken);
            this.isLoading = true;

            DashboardService.getDashboardFunnelResults(this.selection, token, answerIds)
              .then(response => {
                this.isLoading = false;
                this.setFunnelData(response.data);
              })
              .catch(error => {
                console.warn('Error to receive funnel results: ' + error);
                this.isLoading = false;
              });
          } else {
            this.setFunnelData(null);
          }
        } else {
          this.setFunnelData(null);
        }
      },

      setFunnelData(results) {

        // console.log('DashboardPanelFunnel - setFunnelData');
        let data = [];

        for (let line of this.currentLines) {

          if (results && line.questionId != null && line.answerId != null && this.questions && this.questions.QuestionsAnswers && this.questions.QuestionsAnswers.length > 0) {
            const questionValues = this.questions.QuestionsAnswers.find(obj => obj.id === line.questionId);

            if (questionValues && questionValues.answers && questionValues.answers.length > 0) {
              const answerValues = questionValues.answers.find(obj => obj.id === line.answerId);

              let resultItem = this.getResult(results, line.answerId);

              data.push({
                label: answerValues.label,
                value: resultItem.value === 0 ? 1 : resultItem.value,
                dataItem: resultItem
              });
            } else {
              data.push({
                label: this.$t('Webportal.Dashboard.Funnel.ChooseQuestionAnswer'),
                value: 1,
                dataItem: null
              });
            }
          } else {
            data.push({
              label: this.$t('Webportal.Dashboard.Funnel.ChooseQuestionAnswer'),
              value: 1,
              dataItem: null
            });
          }
        }

        // console.log(data);
        this.currentFunnelData = data;
      },

      getResult(results, answerId) {
        let retVal = {
          value: 0,
          noOfChecksBase: 0,
          noOfChecks: 0
        };

        if (results && results.Results && results.Results.length > 0) {

          // calculate result dependent on calculation mode (calculationModeAbs)
          if (this.calculationModeAbs) {

            // a) The result is based on the previous answer (decreasing base check count each line)
            let currentTotal = 0;
            for (let resultItem of results.Results) {
              if (resultItem.AnswerId === answerId) {
                retVal.value = currentTotal > 0 ? (resultItem.Result /  currentTotal) * 100 : 0;
                retVal.noOfChecksBase = currentTotal;
                retVal.noOfChecks = resultItem.Result
                break;
              } else {
                currentTotal = resultItem.Result;
              }
            }
          } else {

            // b) each answer is based on the whole checks (fix base check count each line)
            let currentTotal = results.Results[0].Result;
            for (let resultItem of results.Results) {
              if (resultItem.AnswerId === answerId) {
                retVal.value = currentTotal > 0 ? (resultItem.Result /  currentTotal) * 100 : 0;
                retVal.noOfChecksBase = currentTotal;
                retVal.noOfChecks = resultItem.Result
                break;
              }
            }
          }
        }

        //console.log('DashboardPanelFunnel - getResult: ' + retVal);
        return retVal;
      },

      getFunneldata(reset = true) {

        const token = this.initCancelToken(this.cockpitCancelToken);

        this.isLoading = true;
        if (reset)
          this.resetCurrentLines();

        if (this.selection && this.selection.surveys) {
          // read funneldata
          DashboardService.getDashboardFunnelData(this.selection, token)
            .then(response => {
              this.isLoading = false;
              this.questions = response.data;
            })
            .catch(error => {
              console.warn('Error to receive funnel data: ' + error);
              this.isLoading = false;
            });
        }
      },

      initCancelToken(token) {
        // console.log('DashboardPanelFunnel - initCancelToken');

        // Cancel previous request
        if (token)
          token.cancel();
        return axios.CancelToken.source();
      },

      resetCurrentLines() {
        for (let line of this.currentLines) {
          line.questionId = null;
          line.answerId = null;
        }
      },

      getQuestionOptions() {
        let retVal = [];

        if (this.questions && this.questions.QuestionsAnswers && this.questions.QuestionsAnswers.length > 0) {
          retVal = this.questions.QuestionsAnswers;
        }

        return retVal;
      },

      getQuestionOptions2() {
        let retVal = [];

        if (this.questions && this.questions.QuestionsAnswers && this.questions.QuestionsAnswers.length > 0) {
          retVal = this.questions.QuestionsAnswers.map(obj => obj.label);
        }

        return retVal;
      },

      getAnswerOptions(questionId) {
        let retVal = [];

        if (questionId != null && this.questions.QuestionsAnswers && this.questions.QuestionsAnswers.length > 0) {
          const q = this.questions.QuestionsAnswers.find(obj => obj.id === questionId);
          if (q) {
            retVal = q.answers;
          }
        }

        return retVal ;
      },

      getResultText(options) {
        // console.log(options);

        var retVal = options.item.argument;
        let value = options.item.value;

        // special logic: funnel value is at least 1 because if it's 0 it will not be displayed.
        // so we have to display 0% if the 'real' value is 0. Maybe the value is 'real' 1
        // then we still have to display 1%
        // if (value === 1 && options.item.data.dataItem.noOfChecks != null && options.item.data.dataItem.noOfChecks === 0) {
        //   value = 0;
        // }

        if (value != null && value != undefined && !Number.isNaN(value)) {
          if (options.item && options.item.data && options.item.data.dataItem) {
            retVal = retVal + '<br />';

            if (value === 100) {
              // don't use decimal format only display '100%'
              retVal = retVal + this.$n(value, { minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
            } else if (value === 1 && options.item.data.dataItem.noOfChecks != null && options.item.data.dataItem.noOfChecks === 0) {
              // special logic: funnel value is at least 1 because if it's 0 it will not be displayed.
              // so we have to display 0% if the 'real' value is 0. Maybe the value is 'real' 1
              // then we still have to display 1%
              retVal = retVal + '0%';
            } else
            {
              // default display in client config decimal format
              retVal = retVal + this.$n(value, { minimumFractionDigits: this.percentageNumberOfDecimalPoints, maximumFractionDigits: this.percentageNumberOfDecimalPoints}) + '%';
            }

            // add the # of checks
            if (options.item.data.dataItem.noOfChecks != null && options.item.data.dataItem.noOfChecksBase != null) {
              retVal = retVal + ' (' + options.item.data.dataItem.noOfChecks + '/' + options.item.data.dataItem.noOfChecksBase + ')';
            }
          }
        }

        if (options.valueText) {
          options.valueText = retVal;
        }
        return retVal;
      },

      checkSurveySelectionIsValid() {
        this.surveySelectionIsValid = this.selection && this.selection.surveys && this.selection.surveys.length > 0 && this.selection.surveys.indexOf(',') < 0;
        return this.surveySelectionIsValid;
      },

      checkFilterChanged(newVal, oldVal) {
        // console.log('DashboardPanelFunnel - checkFilterChanged');

        let retVal = false;

        // if no last filter selection available treat it like a filter change
        if (!oldVal) {
          return true;
        }

        // check each filter selection
        const currentFilterSelection = newVal;

        retVal = currentFilterSelection.client !== oldVal.client;
        retVal = retVal | currentFilterSelection.projects !== oldVal.projects;
        retVal = retVal | currentFilterSelection.surveys !== oldVal.surveys;
        retVal = retVal | currentFilterSelection.waves !== oldVal.waves;
        retVal = retVal | currentFilterSelection.scenarios !== oldVal.scenarios;
        retVal = retVal | currentFilterSelection.dateFrom?.getTime() !== oldVal.dateFrom?.getTime() ||
          currentFilterSelection.dateTo?.getTime() !== oldVal.dateTo?.getTime();
        retVal = retVal | currentFilterSelection.locations !== oldVal.locations;
        retVal = retVal | currentFilterSelection.customProperties !== oldVal.customProperties;

        return retVal;
      },
    },

    computed: {
    }
  }
</script>

<style lang="scss" scoped>

  .bootstrap-select .filter-option {
    white-space: normal;
  }

  .flex-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }

  .start-end-question {
    font-weight: bold;
    font-size: 18px;
    width: 100%;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .space-left {
    margin-left: 5px;
  }

  .smallFont {
    font-size: 12px;
  }

  .minHeight400{
    min-height: 400px;
  }

  .right{
    display:block;
    float:right;
    margin-right:0%;
    font-size: 12px;
  }

  .header-container {
    width: 800px;
    padding-right: 0px;
    padding-left: 0px;
    height: 38px;
  }

  .inlined {
    display: inline-block;
  }

  .inlined2 {
    display: inline-block;
    margin-top: 0px;
    top: -5px;
  }

  .tdct
  {
     margin:0px;
     padding: 0px;
     margin-right: 0px;
  }

  .card-header:first-child {
      border-radius: 0rem;
      margin: 0px;
      padding: 0px;
  }

  .card-header{
    background: #BFBFBF;
    height: 40px;
    margin: 0px;
    padding: 0px;
  }

  .card{
    border: none;
    margin-left: 0px;
    margin-top: 5px;
  }

  .card-body {
    padding: 10px;
    margin-top: 2px;
  }

  .firstAndLastLine {
    background: #e4e5e6;
  }

  h3{
      height: 36pt;
      line-height: 28pt;
      text-align: center;
      color: #111111;
      font-size: 16pt;
      font-stretch: extra-condensed;
  }

  div.leftImage {
    position: absolute;
    left: 3px;
    top: 0px;
    bottom: 1px;
  }

  .funnel-background{
    background: #C0C0C0;
  }

</style>
